import type { IntegrationState, SourceSystem } from "./types";

export interface PersistedIntegrationCheck {
  source: SourceSystem;
  baselineGenerationId: string | null;
  expiresAt: number;
}

export function integrationCheckCompleted(
  check: PersistedIntegrationCheck,
  state: IntegrationState | undefined,
): boolean {
  if (!state || state.source_system !== check.source) return false;
  const currentGenerationId = state.credential_generation_id ?? state.request_id ?? null;
  return Boolean(
    currentGenerationId
      && currentGenerationId !== check.baselineGenerationId,
  );
}
